var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemelistIconViewCount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6C16 4.68647 12.7245 0.5 8.00295 0.5C3.31096 0.5 0 4.68647 0 6C0 7.30706 3.33456 11.5 8.00295 11.5C12.7304 11.5 16 7.30706 16 6ZM5.53846 6C5.53846 4.64997 6.64053 3.55556 8 3.55556C9.35947 3.55556 10.4615 4.64997 10.4615 6C10.4615 7.35003 9.35947 8.44444 8 8.44444C6.64053 8.44444 5.53846 7.35003 5.53846 6Z"
  })));
}
export default SvgThemelistIconViewCount;